import React from 'react';
import './styles/theme.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Projects from './components/Projects/Projects';
import Services from './components/Services/Services';
import Sectors from './components/Sectors/Sectors';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import MatrixBackground from './components/MatrixBackground/MatrixBackground';

function App() {
  return (
    <div className="App">
      <MatrixBackground />
      <Header />
      <Hero />
      <About />
      <Projects />
      <Services />
      <Sectors />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
